import {FormControl, Validators} from '@angular/forms';

// @dynamic
export class RcValidators extends Validators {

    public patterns: any = {
        EMAIL: /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
        ONLY_NUMBERS: /^\d+$/,
        ID_NUMBER: '^[0-9]+$',
    };

    static validateCharacters(validCharacters) {
        return (control: FormControl) => {
            if (control.value && control.value.length > 0) {
                const matches = control.value.match(validCharacters);
                const empty = control.value.trim().length === 0;
                return !empty && matches && matches.length ? null : {invalidCharacters: true};
            } else {
                return null;
            }
        };
    }

    static validateIdNumber(): any {
        return (control: FormControl) => {
            if (control.value && control.value.length > 0) {
                let id = String(control.value).trim();

                if (id.length > 9 || id.length < 5) {
                    return false;
                }

                // Pad string with zeros up to 9 digits
                id = id.length < 9 ? ('00000000' + id).slice(-9) : id;

                return Array.from(id, Number).reduce((counter, digit, i) => {
                    const step = digit * ((i % 2) + 1);
                    return counter + (step > 9 ? step - 9 : step);
                }) % 10 === 0 ? null : {invalidCharacters: true};
            } else {
                return null;
            }
        };
    }

    static minLength(length) {
        return (control: FormControl) => {
            if (control.value) {

                return control.value.toString().length >= length ? null : {minlength: true};
            } else {
                return null;
            }
        };
    }

    static maxLength(length) {
        return (control: FormControl) => {
            if (control.value) {

                return control.value.toString().length <= length ? null : {maxlength: true};
            } else {
                return null;
            }
        };
    }

    static maxValue(value) {
        return (control: FormControl) => {
            if (control.value !== null) {
                return control.value <= value ? null : {maxvalue: true};
            } else {
                return null;
            }
        };
    }

    static minValue(value) {
        return (control: FormControl) => {
            if (control.value !== null) {
                return control.value >= value ? null : {minvalue: true};
            } else {
                return null;
            }
        };
    }

    static matchPassword(compareControl: FormControl) {
        return (control: FormControl) => {
            const value = compareControl.value;
            if (control.value && value !== null) {
                return control.value.toString() === value.toString() ? null : {matchPassword: true};
            } else {
                return null;
            }
        };
    }

  static unMatchValue(compareControl: FormControl) {
    return (control: FormControl) => {
      const value = compareControl.value;
      if (control.value && value !== null) {
        return control.value.toString() !== value.toString() ? null : {unMatchValue: true};
      } else {
        return null;
      }
    };
  }
}
